var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(Object.keys(_vm.survey).length)?_c(_vm.get_component,{tag:"component",attrs:{"survey":_vm.get_avg()}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }